module.exports = __webpack_public_path__ + "img/3_6.de8954c6.png";